"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = each;

var _defs = _interopRequireDefault(require("../_core/defs"));

var _forown = _interopRequireDefault(require("../_helpers/forown"));

// iterates over data keys and calls callback on every iteration
// @IE for..of is preferable and the method will be removed in one of major versions
function each(callback, thisArg) {
  var _this = this;

  var def = _defs["default"].get(this);

  var ctx = typeof thisArg !== 'undefined' ? thisArg : this;
  /* istanbul ignore if */

  if (!def) {
    return this;
  }

  (0, _forown["default"])(def.keys, function (_, key) {
    callback.call(ctx, _this[key], key, _this);
  });
  return this;
}
//# sourceMappingURL=each.js.map